<template>
  <div>
    <div class="mobile-menu" :class="{'is-active': isSidebarActive}">
      <app-sidenav v-on:resetClick="closeRoute"></app-sidenav>
    </div>

    <div class="layout">
      <div class="layout-item is-hidden-x">
        <div class="side-panel">
          <app-sidenav v-on:resetClick="closeRoute"></app-sidenav>
        </div>
      </div>
      <div class="layout-item">
        <router-view></router-view>
      </div>
      <div class="layout-item grow amenity-map-container" :class="{'active-venue': activeVenue}">
        <div id="amenity-map" ref="amenity-map">
          <div class="custom-control">
            <a @click="toggle3d()">
              <img src="@/assets/icons/td.svg" alt="">
            </a>
          </div>

          <app-map-label :labels="{lotsize: true}" v-if="!mobileView || !activeVenue"></app-map-label>
        </div>
      </div>
      <div class="layout-item place-info" v-if="activeVenue">
        <button class="modal-close is-large" aria-label="close" @click="closeRoute()"></button>
        <p class="places-info-title">
          {{ activeVenue.name }}
        </p>
        <p class="places-info-subtitle">
          {{ activeVenue.subtype }}
        </p>
        <p class="places-info-description">
          {{ activeVenue.description }}
        </p>
        <a v-if="activeVenue.url" target="_blank" :href="activeVenue.url">
          View Website
        </a>
        <div v-if="route" class="sidepanel-route">
          <hr>
          <div class="direction-buttons">
            <div class="buttons has-addons">
              <div class="buttons has-addons is-fullwidth">
                <button class="button is-small" :class="{'is-active': method === 'driving'}"
                        @click="changeMethod('driving')">
                  <img v-if="method !== 'driving'" src="@/assets/icons/driving.svg" alt="">
                  <img v-if="method === 'driving'" src="@/assets/icons/driving_white.svg" alt="">
                </button>
                <button class="button is-small" :class="{'is-active': method === 'cycling'}"
                        @click="changeMethod('cycling')">
                  <img src="@/assets/icons/cycling.svg" alt="" v-if="method !== 'cycling'">
                  <img src="@/assets/icons/cycling_white.svg" alt="" v-if="method === 'cycling'">
                </button>
                <button class="button is-small" :class="{'is-active': method === 'walking'}"
                        @click="changeMethod('walking')">
                  <img src="@/assets/icons/walking.svg" alt="" v-if="method !== 'walking'">
                  <img src="@/assets/icons/walking_white.svg" alt="" v-if="method === 'walking'">
                </button>
              </div>
            </div>
          </div>
          <hr>
          <div class="route-summary">
            <div class="left-item">
              <p>Via {{ routeInfo.legs[0].summary }}</p>
              <a class="small is-ghost" @click="showRoute = !showRoute">
                <span v-if="!showRoute">Show</span>
                <span v-if="showRoute">Hide</span>
                Route
              </a>
            </div>
            <div class="right-item">
              <p>
                {{ getTime(route.duration, true) }}
              </p>
              <p>
                {{ getDistance(route.distance) }}
              </p>
            </div>
          </div>

          <div class="steps"
               v-if="showRoute && routeInfo && routeInfo.legs && routeInfo.legs.length && routeInfo.legs[0].steps">
            <table class="table is-fullwidth">
              <tr v-for="steps in routeInfo.legs[0].steps">
                <td>
                  <img v-if="steps['icon']" :src="require('@/assets/diving_icons/' + steps.icon)" alt="">
                </td>
                <td class="instruction">{{ steps.maneuver.instruction }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="gallery" uk-lightbox>
          <div class="columns is-multiline is-variable is-1" v-if="activeVenue.gallery.length > 0">
            <div class="column is-12"
                 v-for="image of activeVenue.gallery.filter(item => item.primary)">
              <a :href="image.url" v-if="isImage(image.url)">
                <figure class="image is-3by2">
                  <img :src="image.url" alt="">
                </figure>
              </a>
              <a :href="image.url" data-type="video" v-if="!isImage(image.url)">
                <video :src="image.url" loop muted playsinline uk-video="autoplay: inview"></video>
              </a>
            </div>

            <div class="column is-12"
                 v-for="image of activeVenue.gallery.filter(item => item.secondary)">
              <a :href="image.url" v-if="isImage(image.url)">
                <figure class="image is-3by2">
                  <img :src="image.url" alt="">
                </figure>
              </a>
              <a :href="image.url" data-type="video" v-if="!isImage(image.url)">
                <video :src="image.url" loop muted playsinline uk-video="autoplay: inview"></video>
              </a>
            </div>
          </div>

          <div class="columns is-variable is-1 is-multiline" v-if="activeVenue.gallery.length > 0">
            <div class="column is-6"
                 v-for="image of activeVenue.gallery.filter(item => !item.primary && !item.secondary)">
              <a :href="image.url" data-lightbox="amenity" v-if="isImage(image.url)">
                <figure class="image is-3by2">
                  <img :src="image.url" alt="">
                </figure>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Amenity from "@/mixins/Amenity";

import Sidenav from "./Nav";
import Common from "@/mixins/Common";
import MapLabel from "@/components/journey/MapLabel";

export default {
  name: 'amenity-map',
  mixins: [Amenity, Common],
  components: {
    'app-sidenav': Sidenav,
    'app-map-label': MapLabel
  },
  data() {
    return {
      activeMenu: '',
      activePoi: null,
      isPitched: true,
      lotload: null,
      method: 'driving',
      mobileView: false,
      routeInfo: null,
      showRoute: false,
      venues: [],
      isSidebarActive: false,
    }
  },
  watch: {
    mapLoad: function (val, oldVal) {
      if (val) {
        this.categorisePoi()
      }
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setActivePoi') {
        this.clearMap();
        this.addMarkers(state.amenityStore.activePoi)
      }

      if (mutation.type === 'setActiveVenue') {
        this.getActiveVenue(state.amenityStore.activeVenue);
      }

      if (mutation.type === 'setDirectionMethod') {
        if (state.amenityStore.directionMethod) {
          this.travelMethod = state.amenityStore.directionMethod;
          this.getActiveVenue(state.amenityStore.activeVenue);
        }
      }

      if (mutation.type === 'setActiveTravel') {
        const travel = state.amenityStore.activeTravel;
        if (travel) {
          this.getDirection(travel.coord, travel.method, travel.swapped, true)
        }
      }

      if (mutation.type === "setRouteInfo") {
        this.routeInfo = state.amenityStore.routeInfo;
        if (this.routeInfo && this.routeInfo.legs && this.routeInfo.legs.length && this.routeInfo.legs.length) {
          this.setIcons(this.routeInfo.legs[0].steps);
        }
      }

      if (mutation.type === 'zoomToCategory') {
        if (state.amenityStore.category) {
          this.zoomToCategory(state.amenityStore.category);
        }
      }

      if (mutation.type === 'setMasterplanConfig') {
        if (state.communityStore.masterplanConfig) {
          this.masterplanConfig = state.communityStore.masterplanConfig;
          this.loadMap()
        }
      }

      if (mutation.type === 'setUnfilteredSummaryList') {
        this.lotload = state.communityStore.unfilteredLotSummary;
        this.loadMap();
      }
    })

    this.$store.dispatch('fetchMasterplanConfig');
    this.$store.dispatch('fetchLotSummaryList');

    this.$router.afterEach(((to, from) => {
      this.clearMap();
    }))
    this.activeMenu = this.$route.name;
    this.mobileView = window.innerWidth <= 600;
  },
  methods: {
    getActiveVenue: function (activeVenue) {
      this.activeVenue = activeVenue;
      if (this.activeVenue) {
        if (this.mobileView) {
          this.map.dragPan.disable();
          this.map.scrollZoom.disable();
        }
        this.$store.dispatch('productTracking', {page: 'poi-click', product: {productName: activeVenue.name, category: activeVenue.category}})
        if (this.activeVenue.hasOwnProperty('showRoute')) {
          if (this.activeVenue.showRoute) {
            this.padding = {top: 100, left: 100, right: 400, bottom: 100};
            this.getDirection([this.activeVenue.longitude, this.activeVenue.latitude])
          } else {
            this.flyToPoint([this.activeVenue.longitude, this.activeVenue.latitude])
            this.route = null;
          }
          this.highlightPoi(this.activeVenue);
        }
      } else {
        this.map.scrollZoom.enable();
        this.map.dragPan.enable();
        this.padding = {top: 100, left: 100, right: 100, bottom: 100};
        this.map.fitBounds(this.masterBound);
        // if (this.markerBounds) {
        //   this.map.fitBounds(this.markerBounds);
        // } else {
        //   this.map.fitBounds(this.masterBound)
        // }
        setTimeout(() => {
          this.resize();
        })
      }
    },

    loadMap: function () {
      if (this.masterplanConfig && this.lotload) {
        this.initMap(this.masterplanConfig, this.lotload);
      }
    },

    changeMethod(method) {
      this.method = method
      this.$store.commit("setDirectionMethod", this.method);
    },

    toggle3d() {
      const pitch = this.isPitched ? 0 : 60
      this.isPitched = !this.isPitched;
      this.map.flyTo({
        pitch: pitch
      });
    },

    closeRoute: function () {
      this.route = null;
      this.clearRoutes();
      this.$store.commit("setActiveVenue", null);
      this.$store.commit("setRouteInfo", null);
    },

    isImage(url) {
      return (url.match(/\.(jpeg|jpg|gif|png|svg)$/) != null);
    },

    toggleSidebar: function () {
      this.isSidebarActive = !this.isSidebarActive;
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/amenities/Map.vue